/**
 * Trolley payout setup (#700). Reads the app-proxy endpoint and the logged-in
 * customer id from the mount element's data attributes, POSTs to the proxy for
 * a fresh signed Trolley Recipient Widget URL (Shopify auto-adds the proxy
 * signature + logged_in_customer_id), and embeds that URL inline in an iframe.
 * Pairs with app PR #764 (POST /api/customer/payoutSetupLink).
 */
(function () {
  function init() {
    const mount = document.getElementById('trolley-widget');
    const status = document.getElementById('trolley-status');
    if (!mount || !status) return;

    const proxy = mount.dataset.proxy;
    const customerId = mount.dataset.customerId;
    // Strings are localized in the section template and passed through as data attributes.
    const errorText = mount.dataset.errorText;

    // customer.id renders empty when logged out.
    if (!customerId) {
      status.textContent = mount.dataset.loginText;
      return;
    }

    fetch(proxy, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: customerId }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        const url = res && (res.url || (res.result && res.result.url));
        if (!res || res.status !== true || !url) {
          status.textContent = (res && res.message) || errorText;
          return;
        }

        const iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.width = '100%';
        iframe.height = '900';
        iframe.style.border = '0';
        iframe.title = mount.dataset.widgetTitle;
        iframe.setAttribute('allow', 'clipboard-write');
        status.remove();
        mount.appendChild(iframe);
      })
      .catch(function () {
        status.textContent = errorText;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
